var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mount_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 544 237",
    style: {
      enableBackground: "new 0 0 544 237"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mount1{fill:#63DBD0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mount1",
    d: "M514.2,219.7c13.7,13.7,30.2,17.1,29.8,17.1c-25,0-13.1,0-50,0c-35.2,0-70.1-0.1-109.6,0 c-40.8,0.1-81.4,0-118.4,0c-54.6,0.1-73.7,0-132.8,0c-39.9,0-44.6,0-89,0c-10.4,0-14.4,0-23.5,0c-2.4,0-2.6,0-13.1,0 c-1.5,0-2.7,0-5.3,0c-1.3,0-1.5,0-2.2,0c-3.4,0.1,147.1-224.2,266-235.4C379.5-4.3,406.2,118.5,514.2,219.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium1);
export default __webpack_public_path__ + "static/media/podium_1.7cd00df7ff3f44433d6ecb500eed561b.svg";
export { ForwardRef as ReactComponent };